import { render, staticRenderFns } from "./CompanyIntroduce.vue?vue&type=template&id=bbb9c62a&scoped=true"
import script from "./CompanyIntroduce.vue?vue&type=script&lang=js"
export * from "./CompanyIntroduce.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntroduce.vue?vue&type=style&index=0&id=bbb9c62a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb9c62a",
  null
  
)

export default component.exports